import React from 'react';
const AtFlag = () => (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", id: "flag-icons-at", viewBox: "0 0 640 480" },
    React.createElement("g", { fillRule: "evenodd" },
        React.createElement("path", { fill: "#fff", d: "M640 480H0V0h640z" }),
        React.createElement("path", { fill: "#c8102e", d: "M640 480H0V320h640zm0-319.9H0V.1h640z" }))));
export default AtFlag;
//# sourceMappingURL=at.js.map